import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import logo from "./assets/logo.png";
import { FaCheck, FaTimes } from "react-icons/fa";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import openNotification from "./utils/CustomNotification";
import { Link } from "react-router-dom";
import "../styles/Login.css";
import { collectDeviceInfo } from "../../src/components/utils/deviceInfo";
const SvgWrapper = styled.div`
  width: 100%; /* Make SVG take full width */
  height: auto; /* Allow height to scale */
  position: relative; /* Position relative for absolute children */
`;
const OrDivider = styled.div`
  display: flex;
  align-items: center;
  margin: 1rem 0;
  color: #666; /* Adjust color as needed */
  font-size: 1rem; /* Adjust font size as needed */

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: var(--page-color); 
    margin: 0 1rem;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
`;

const Card = styled.div`
  /* width: 400px; */
  width: 30%;
  background-color: #ffffff;
  border-radius: 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: center;

  @media (max-width: 1024px) {
    width: 40%;
  }

  @media (max-width: 768px) {
    width: 50%;
  }

  @media (max-width: 480px) {
    width: 90%;
  }
`;

// const Header = styled.div`
//   background-color: #a6f0ff;
//   border-top-left-radius: 15px;
//   border-top-right-radius: 15px;

//   padding: 30px 0 10px;
//   color: #017b9f;
// `;

// const Logo = styled.h1`
//   font-size: 28px;
//   font-weight: bold;
//   margin-bottom: 5px;
// `;

const Subtitle = styled.p`
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 1rem; /* 25px equivalent */
  line-height: 1.2rem; /* 30.26px equivalent */
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  @media (min-width: 1500px) {
    margin-top: 13%;
  }
  @media (min-width: 2000px) {
    margin-top: 20%;
  }

  span {
    display: block; /* Ensures each part is on a separate line */
  }
`;

const Form = styled.form`
  margin-top: 20px;
`;

// const InputGroup = styled.div`
//   display: flex;
//   flex-direction: column;
// `;
// const SvgWrapper = styled.div`
//   transform: translateY(-190px); /* Adjust the value to move it up */
// `;

// const Input = styled.input`
//   max-width: 100%; /* Ensures it doesn’t exceed its container */
//   min-width: 250px; /* Sets a reasonable minimum width */
//   padding: 12px 15px;
//   border: 1px solid #ddd;
//   border-radius: 8px;
//   font-size: 14px;
//   outline: none;

//   @media (max-width: 600px) {
//     font-size: 12px; /* Adjust font size for smaller screens */
//     padding: 10px 12px; /* Reduce padding for smaller screens */
//   }

//   &:focus {
//     border-color: #017b9f;
//   }
// `;

// const InputIcon = styled.div`
//   position: absolute;
//   top: 50%;
//   /* right: 10px; */
//   transform: translateY(-50%);
//   font-size: 18px;
//   color: #ccc;
//   cursor: pointer;
// `;

const Button = styled.button`
  width: 80%;
  padding: 10px 0;
  font-family: Inter;
  font-size: 22px;
  font-weight: 500;
  line-height: 22px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  background: #aaeff4;
  color: #000;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 10px;
  box-shadow: 0px 4px 4px 0px #00000040;

  &:hover {
    background-color: #009ec3;
  }
`;
const OtpButton = styled.button`
  width: 80%;
  padding: 12px 0;
  font-family: Inter;
  font-size: 22px;
  font-weight: 500;
  line-height: 22px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  background: #aaeff4;
  color: #000;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 10px;
  box-shadow: 0px 4px 4px 0px #00000040;

  &:hover {
    background-color: #009ec3;
  }
`;
const ForgotPassword = styled.a`
  display: flex;
  justify-content: flex-end;
  font-size: 12px;

  &:hover {
    text-decoration: underline;
  }
`;
const Down = styled.div`
  /* display: flex; */
  /* background-color: #00d2ff; */
  padding: 2rem;
`;
const AuthInputGroup = styled.div`
  margin-top: 4%;
  position: relative;
`;

const AuthLabel = styled.label`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
`;

const InputWithIcon = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const AuthInput = styled.input`
  width: 100%;
  padding: 10px 15px;
  font-size: 14px;

  border-radius: 8px;
  outline: none;
  transition: border-color 0.3s;

  &.valid {
    border-color: #4caf50;
  }

  &.invalid {
    border-color: #ff6347;
  }

  &.disabled {
    background-color: #f0f0f0;
    cursor: not-allowed;
  }
`;

const ValidIcon = styled(FaCheck)`
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`;

const InvalidIcon = styled(FaTimes)`
  position: absolute;
  right: 10px;
  color: #ff6347;
`;
const EyeIcon = styled(FaEye)`
  position: absolute;
  right: 10px;
  color: #333;
  cursor: pointer;
`;

const EyeSlashIcon = styled(FaEyeSlash)`
  position: absolute;
  right: 10px;
  color: #333;
  cursor: pointer;
`;
const Register = styled.div`
  /* margin-top: 20px; */
  font-size: 12px;

  a {
    color: #017b9f;
    text-decoration: none;
    font-weight: bold;

    &:hover {
      text-decoration: underline;
    }
  }
`;
const OtpInputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* margin-top: 20px; */
`;

const AuthOtpInstructions = styled.p`
  font-size: 14px;
  color: #555;
  margin-bottom: 10px;
`;

const OtpBoxes = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const OtpInput = styled.input`
  width: 30px;
  height: 30px;
  text-align: center;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.3s;

  &:focus {
    border-color: #ff6347;
  }

  &:disabled {
    background-color: #f0f0f0;
    cursor: not-allowed;
  }
`;
const SubmitOtp = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Footer = styled.div`
  font-family: Inter;
  padding: 1rem;
  font-weight: 500;
  line-height: 19.36px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 19.36px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;
// Define the response types for the API calls.
const Service = styled.span`
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 19.36px;
  text-align: center;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-underline-position: from-font;
  text-decoration-skip-ink: auto;
  color: #017b9f;
`;
interface UIDirective {
  type: string;
  message: string;
}

interface LoginResponse {
  status: string;
  data: {
    session_uid: string;
    user_uid: string;
    expiry_datetime: string;
    timeout_interval: string;
    is_initial_login: boolean;
    mapp_consent?: boolean;
    two_fa_enabled?: boolean;
    user_info?: {
      org_uid: string;
      privilege: string;
      user_role: string;
      timezone: string;
      session_timeout: string;
      org_image_uid: string;
      release_group: string;
      mapp_consent: boolean;
    };
  };
  ui_directives?: UIDirective[];
}

interface OTPResponse {
  status: string;
  data: {
    session_uid: string;
    user_uid: string;
    expiry_datetime: string;
    timeout_interval: string;
    user_info: UserInfo;
    is_initial_login: boolean;
    mapp_consent?: boolean;
  };
  message: string;
}

interface UserInfo {
  org_uid: string;
  privilege: string;
  device_control: boolean;
  device_control_role: string;
  user_role: string;
  user_manage_access: boolean;
  user_control_role: string;
  theme: string;
  timezone: string;
  session_timeout: string;
  refresh_time: string;
  metric_filter_type: string;
  metric_filter_value: string;
  message: string;
  mapp_consent: boolean;
  org_image_uid: string;
  release_group: string;
}
interface ResponseData {
  status: string;
  data: {
    session_uid: string;
    user_uid: string;
    expiry_datetime: string;
    timeout_interval: string;
    message?: string; // Add this line
  };
}
const Login: React.FC = () => {
  const [otpInput, setOtpInput] = useState<string[]>(new Array(6).fill(""));
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [emailValid, setEmailValid] = useState<boolean>(false);
  const [otpSession, setOtpSession] = useState<boolean>(false);
  // const [otpInput, setOtpInput] = useState<string[]>(new Array(6).fill(""));
  const [otpSent, setOtpSent] = useState<boolean>(false);
  const [otpSubmitting, setOtpSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();
  const [isLoginDisabled, setIsLoginDisabled] = useState<boolean>(false);
  const [showLowercaseWarning, setShowLowercaseWarning] = useState(false);
  const hasDownloaded = localStorage.getItem("download_completed") === "true";
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  // const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const [useRecoveryCode, setUseRecoveryCode] = useState(false);
  const [recoveryPassword, setRecoveryPassword] = useState("");
  const [showRecoveryPassword, setShowRecoveryPassword] = useState(false);

  const beAddress =
    window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL;

  useEffect(() => {
    // Push the current state again to create a buffer
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      // If user clicks Back, immediately push them forward again
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const handleMetircFilter = () => {
    if (
      !localStorage.getItem("startDateTime") &&
      !localStorage.getItem("endDateTime")
    ) {
      localStorage.setItem(
        "endDateTime",
        moment
          .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
      );
      localStorage.setItem(
        "startDateTime",
        moment
          .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
          .subtract(parseInt("1", 10), "hours")
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
      );
    }
  };

  const handleSubmit = async (
    event: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    event.preventDefault();
    setOtpInput(new Array(6).fill(""));

    if (
      localStorage.getItem("user_uid") &&
      localStorage.getItem("session_uid")
    ) {
      openNotification({
        type: "info",
        message:
          "An active session already exists for this domain. Please refresh the page to continue using it.",
      });
      return;
    }

    setIsLoginDisabled(true);
    if (!email || !password) {
      openNotification({
        type: "error",
        message: "Please enter Email and Password",
      });
      setIsLoginDisabled(false);
      return;
    }

    try {
      const deviceInfo = collectDeviceInfo();

      const response = await axios.post<LoginResponse>(
        `${beAddress}/api/v1/login`,
        {
          user_uid: email,
          password: password.trim(),
          device_info: deviceInfo,
        },
        {
          headers: {
            "user-uid": email,
          },
          withCredentials: true,
        },
      );

      if (response.status === 200) {
        const responseData = response.data;

        if (responseData.status === "Failed") {
          const isPasswordExpired =
            typeof responseData.data === "string" &&
            (responseData.data as string)
              .toLowerCase()
              .includes("password expired");

          if (isPasswordExpired) {
            openNotification({
              type: "warning",
              message:
                "Your password has expired. Please reset it to continue.",
            });

            localStorage.setItem("password_expired", "true");

            setTimeout(() => {
              navigate("/reset-password");
            }, 100);
            return;
          }

          openNotification({
            type: "error",
            message: responseData.data,
          });
          setIsLoginDisabled(false);
          return;
        }
        if (responseData.status !== "Success") {
          openNotification({
            type: "error",
            message: responseData.data,
          });
          setIsLoginDisabled(false);
          return;
        }

        const {
          session_uid,
          user_uid,
          expiry_datetime,
          timeout_interval,
          is_initial_login,
          mapp_consent,
          two_fa_enabled,
          user_info,
        } = responseData.data;

        // session uid from cookies 


        // Save common fields
        localStorage.clear();
        localStorage.setItem("user_uid", user_uid);
        localStorage.setItem("otp_session_uid", session_uid);
        localStorage.setItem("expiry_datetime", expiry_datetime);
        localStorage.setItem("timeout_interval", timeout_interval);
        localStorage.setItem("is_initial_login", String(is_initial_login));
        localStorage.setItem("mapp_consent", mapp_consent ? "true" : "false");

        if (Array.isArray(responseData.ui_directives)) {
          const warnings = responseData.ui_directives.filter(
            (directive: UIDirective) =>
              directive?.type === "warning" && directive?.message
          );
          if (warnings.length > 0) {
            localStorage.setItem("ui_warnings", JSON.stringify(warnings));
          }
        }

        if (two_fa_enabled) {
          setOtpSession(true);
          setOtpSent(true);
          openNotification({
            type: "info",
            message:
              "Please enter the OTP displayed in your authenticator app.",
          });
        } else {
          // Direct login: Save user_info as well
          if (user_info) {
            localStorage.setItem("session_uid", session_uid);
            localStorage.setItem("org_uid", user_info.org_uid);
            localStorage.setItem("privilege", user_info.privilege);
            localStorage.setItem("user_role", user_info.user_role);
            localStorage.setItem("timeZone", user_info.timezone);
            localStorage.setItem("session_timeout", user_info.session_timeout);
            localStorage.setItem("org_image_uid", user_info.org_image_uid);
            localStorage.setItem("release_group", user_info.release_group);
            localStorage.setItem(
              "mapp_consent",
              user_info.mapp_consent.toString()
            );
          }

          handleMetircFilter();

          openNotification({
            type: "success",
            message: "Login successful!",
          });


          const isInitialLoginStored =
            localStorage.getItem("mapp_consent") === "true";

          navigate(isInitialLoginStored ? "/home" : "/app-download");
        }
      } else {
        openNotification({
          type: "error",
          message: "Unprocessable Entity",
        });
      }
    } catch (error) {
      console.error("Login error:", error);
      openNotification({
        type: "error",
        message: "Unable to reach servers",
      });
    } finally {
      setIsLoginDisabled(false);
    }
  };

  const handleOTPSubmit = async (
    event:
      | React.KeyboardEvent<HTMLInputElement>
      | React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    if (otpSubmitting) return;
    setOtpSubmitting(true);

    const otp = useRecoveryCode ? recoveryPassword : otpInput.join("");
    const operation = useRecoveryCode ? "backup_code" : "2fa_otp";

    if (!otp || !otpSession) {
      openNotification({
        type: "error",
        message: useRecoveryCode
          ? "Please enter recovery code"
          : "Please enter OTP",
      });
      setOtpSubmitting(false);
      return;
    }

    try {
      const response = await axios.post<OTPResponse>(
        `${beAddress}/api/login-validate-2fa-otp`,
        {
          user_uid: localStorage.getItem("user_uid") || "",
          password: password.trim(),
          otp: otp,
          operation: operation,
        },
        {
          headers: {
            "user-uid": localStorage.getItem("user_uid")!,
          },
          withCredentials: true,
        }
      );

      if (response.status === 200 && response.data.status === "Success") {
        const responseData = response.data;
        const { session_uid, user_uid, expiry_datetime, user_info } =
          responseData.data;

        localStorage.removeItem("otp_session_uid");
        localStorage.setItem("session_uid", session_uid);
        localStorage.setItem("user_uid", user_uid);
        localStorage.setItem("org_uid", user_info.org_uid);
        localStorage.setItem("privilege", user_info.privilege);
        localStorage.setItem("user_role", user_info.user_role);
        localStorage.setItem("timeZone", user_info.timezone);
        localStorage.setItem("expiry_datetime", expiry_datetime);
        localStorage.setItem("session_timeout", user_info.session_timeout);
        localStorage.setItem("org_image_uid", user_info.org_image_uid);
        localStorage.setItem("release_group", user_info.release_group);
        localStorage.setItem("mapp_consent", user_info.mapp_consent.toString());
        handleMetircFilter();

        const isInitialLoginStored =
          localStorage.getItem("mapp_consent") === "true";

        navigate(isInitialLoginStored ? "/home" : "/app-download");
      } else {
        openNotification({
          type: "error",
          message: response.data.data,
        });
        setOtpSession(false);
        setOtpSent(false);
        setOtpSubmitting(false);
        setIsLoginDisabled(false);
        setRecoveryPassword("");
      }
    } catch (error) {
      openNotification({
        type: "error",
        message: "Unable to reach server",
      });
      setOtpSubmitting(false);
      setIsLoginDisabled(false);
    }
  };

  const handleOtpChange = (value: string, index: number): void => {
    if (/^[0-9]$/.test(value) || value === "") {
      const newOtpInput = [...otpInput];
      newOtpInput[index] = value;
      setOtpInput(newOtpInput);

      if (value !== "" && index < 5) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>): void => {
    e.preventDefault();

    const pasteData = e.clipboardData.getData("text").trim();
    const digits = pasteData.match(/\d/g);

    if (!digits || digits.length < 6) return;

    const newOtp = otpInput.map((_, i) => digits[i] || "");
    setOtpInput(newOtp);

    // ✅ Auto-focus the last empty field (or last box if all filled)
    const lastIndex = newOtp.findIndex((d) => d === "");
    const nextFocus = lastIndex === -1 ? newOtp.length - 1 : lastIndex;

    setTimeout(() => {
      const el = document.getElementById(`otp-input-${nextFocus}`);
      if (el) (el as HTMLInputElement).focus();
    }, 0);
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ): void => {
    if (e.key === "Backspace" && index > 0 && otpInput[index] === "") {
      inputRefs.current[index - 1]?.focus();
    } else if (e.key === "Enter") {
      handleOTPSubmit(e);
    }
  };

  const handleEmailChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const inputValue = event.target.value;
    const lowerCaseEmail = inputValue.toLowerCase();

    setEmail(lowerCaseEmail);
    setEmailValid(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(lowerCaseEmail));

    if (inputValue !== lowerCaseEmail) {
      setShowLowercaseWarning(true);

      setTimeout(() => {
        setShowLowercaseWarning(false);
      }, 2000);
    }
  };

  return (
    <Container>
      <Card>
        <div style={{ position: "relative", width: "100%", height: "132px" }}>
          {/* Background SVG */}
          {/* Background SVG */}
          <SvgWrapper>
            <svg
              viewBox="0 0 566 261"
              preserveAspectRatio="xMinYMin meet"
              xmlns="http://www.w3.org/2000/svg"
              style={{
                position: "absolute",
                top: "10px",
                left: "0",
                width: "100%",
                height: "auto",
                zIndex: 1,
              }}
            >
              <g filter="url(#filter0_d_491_18403)">
                <path
                  d="M0 0H566V121.87C374.085 86.504 334.083 349.97 0 106.787V0Z"
                  fill="#084852"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_491_18403"
                  x="-4"
                  y="0"
                  width="574"
                  height="269"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_491_18403"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_491_18403"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>

            {/* Foreground SVG */}
            <svg
              viewBox="0 0 566 221"
              preserveAspectRatio="xMinYMin meet"
              xmlns="http://www.w3.org/2000/svg"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "auto", // Allow the height to scale with width
                zIndex: 2,
              }}
            >
              <defs>
                <clipPath id="clipRoundedCorners">
                  <rect x="0" y="0" width="566" height="221" rx="20" ry="20" />
                </clipPath>
                <filter
                  id="filter0_d_491_18404"
                  x="-4"
                  y="0"
                  width="574"
                  height="221"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_491_18404"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_491_18404"
                    result="shape"
                  />
                </filter>
              </defs>
              <g
                clipPath="url(#clipRoundedCorners)"
                filter="url(#filter0_d_491_18404)"
              >
                <path
                  d="M0 0H566V107.104C373.56 101.356 326.5 359.172 0 90.4174V0Z"
                  fill="#AAEFF4"
                />
              </g>
            </svg>
          </SvgWrapper>

          {/* Centered Image and Text */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 3,
              textAlign: "center",
            }}
          >
            <img
              src={logo}
              alt="Center Image"
              style={{ width: "50px", height: "40px", marginBottom: "-5px" }}
            />
            <div
              style={{
                fontSize: "1.6rem", // Consistent size definition
                color: "#000",
                fontWeight: "bold",
                fontFamily: "Inter", // Correct camelCase
                lineHeight: "36.31px",
                letterSpacing: "-0.24px", // Simplified for readability
                textAlign: "center",
                textUnderlinePosition: "from-font",
                textDecorationSkipInk: "none",
              }}
            >
              PulseRank
            </div>
          </div>
        </div>
        <Down>
          <Subtitle>
            <span>Corporate Wellness</span>
            <span>Redefined.</span>
          </Subtitle>
          <Form onSubmit={handleSubmit}>
            <AuthInputGroup>
              <AuthLabel htmlFor="email">Enter Email Address</AuthLabel>
              <InputWithIcon>
                <AuthInput
                  type="email"
                  id="email"
                  className={`auth-input ${emailValid ? "valid" : "invalid"} ${otpSent ? "disabled" : ""
                    }`}
                  placeholder="Enter your email"
                  value={email}
                  onChange={handleEmailChange}
                  disabled={otpSent}
                />
                {emailValid ? <ValidIcon /> : <InvalidIcon />}
              </InputWithIcon>

              {/* Tooltip Message */}
              {showLowercaseWarning && (
                <div className="Login-tooltip">
                  ⚠️ Username will be in lowercase only.
                </div>
              )}
            </AuthInputGroup>
            <AuthInputGroup>
              <AuthLabel htmlFor="password">Enter Password</AuthLabel>
              <InputWithIcon className={otpSent ? "disabled-input" : ""}>
                <AuthInput
                  type={showPassword ? "text" : "password"}
                  id="password"
                  className={otpSent ? "disabled" : ""}
                  placeholder="Enter your password"
                  value={password}
                  disabled={otpSent}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {showPassword ? (
                  <EyeSlashIcon onClick={() => setShowPassword(false)} />
                ) : (
                  <EyeIcon onClick={() => setShowPassword(true)} />
                )}
              </InputWithIcon>
            </AuthInputGroup>
            <Link
              to="/forgot-password"
              className="forgot-password-link"
              style={{
                fontFamily: "'Helvetica', sans-serif",
                fontSize: "14px",
                color: "#017b9f",
                textDecoration: "none",
                transition: "color 0.3s ease, transform 0.2s ease",
                display: "block",
                textAlign: "right",
                marginLeft: "auto",
                marginRight: "0",
              }}
              onMouseEnter={(e) =>
                ((e.target as HTMLElement).style.color = "#017b9f")
              }
              onMouseLeave={(e) =>
                ((e.target as HTMLElement).style.color = "#017b9f")
              }
              onMouseDown={(e) =>
                ((e.target as HTMLElement).style.transform = "scale(1.05)")
              }
              onMouseUp={(e) =>
                ((e.target as HTMLElement).style.transform = "scale(1)")
              }
            >
              Forgot password?
            </Link>
            <Button
              type="submit"
              disabled={isLoginDisabled || otpSent}
              style={{
                backgroundColor:
                  isLoginDisabled || otpSent ? "#ccc" : "#aaeff4",
                cursor: isLoginDisabled || otpSent ? "not-allowed" : "pointer",
              }}
            >
              Login
            </Button>
          </Form>
          {otpSent && (
            <>
              {!useRecoveryCode ? (
                <div className="otp-inputs">
                  <p className="auth-otp-instructions">
                    Please enter the OTP displayed in your authenticator app
                  </p>
                  <OtpBoxes>
                    {otpInput.map((otp, index) => (
                      <OtpInput
                        key={index}
                        type="text"
                        maxLength={1}
                        value={otp}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[0-9]?$/.test(value)) {
                            const newOtpInput = [...otpInput];
                            newOtpInput[index] = value;
                            setOtpInput(newOtpInput);
                            if (value !== "" && index < otpInput.length - 1) {
                              inputRefs.current[index + 1]?.focus();
                            }
                          }
                        }}
                        onKeyDown={(e) => {
                          if (
                            e.key === "Backspace" &&
                            index > 0 &&
                            otp === ""
                          ) {
                            inputRefs.current[index - 1]?.focus();
                          }
                          else if (e.key === "Enter") {
                            handleOTPSubmit(e);
                          }
                        }}
                        onPaste={index === 0 ? handlePaste : undefined}
                        ref={(el) => {
                          inputRefs.current[index] = el;
                        }}
                        id={`otp-input-${index}`}
                        pattern="[0-9]*"
                        inputMode="numeric"
                      />
                    ))}
                  </OtpBoxes>
                  <Link
                    to="#"
                    className="auth-recovery-password"
                    style={{
                      fontFamily: "'Helvetica', sans-serif",
                      fontSize: "14px",
                      color: "#017b9f",
                      textDecoration: "none",
                      transition: "color 0.3s ease, transform 0.2s ease",
                      display: "block",
                      textAlign: "right",
                      marginLeft: "auto",
                      marginRight: "0",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      setUseRecoveryCode(!useRecoveryCode);
                    }}
                    onMouseEnter={(e) =>
                      ((e.target as HTMLElement).style.color = "#017b9f")
                    }
                    onMouseLeave={(e) =>
                      ((e.target as HTMLElement).style.color = "#017b9f")
                    }
                    onMouseDown={(e) =>
                    ((e.target as HTMLElement).style.transform =
                      "scale(1.05)")
                    }
                    onMouseUp={(e) =>
                      ((e.target as HTMLElement).style.transform = "scale(1)")
                    }
                  >
                    {useRecoveryCode
                      ? "Use OTP instead?"
                      : "Use a recovery code?"}
                  </Link>
                  <Button
                    type="button"
                    onClick={handleOTPSubmit}
                    className="auth-button"
                  >
                    Submit OTP
                  </Button>
                </div>
              ) : (
                <div className="recovery-code-section">
                  <p className="auth-otp-instructions">
                    Please enter the recovery password. If you don’t have it,
                    contact the system administrator.
                  </p>
                  <AuthInputGroup>
                    <InputWithIcon className={otpSent ? "disabled-input" : ""}>
                      <AuthInput
                        type={showRecoveryPassword ? "text" : "password"}
                        id="recoveryPassword"
                        placeholder="Enter your recovery password"
                        value={recoveryPassword}
                        onChange={(e) => setRecoveryPassword(e.target.value)}
                        maxLength={15}
                      />
                      {showRecoveryPassword ? (
                        <EyeSlashIcon
                          onClick={() => setShowRecoveryPassword(false)}
                        />
                      ) : (
                        <EyeIcon
                          onClick={() => setShowRecoveryPassword(true)}
                        />
                      )}
                    </InputWithIcon>
                  </AuthInputGroup>
                  <Link
                    to="#"
                    style={{
                      fontFamily: "'Helvetica', sans-serif",
                      fontSize: "14px",
                      color: "#017b9f",
                      textDecoration: "none",
                      transition: "color 0.3s ease, transform 0.2s ease",
                      display: "block",
                      textAlign: "right",
                      marginLeft: "auto",
                      marginRight: "0",
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      setUseRecoveryCode(!useRecoveryCode);
                    }}
                    onMouseEnter={(e) =>
                      ((e.target as HTMLElement).style.color = "#017b9f")
                    }
                    onMouseLeave={(e) =>
                      ((e.target as HTMLElement).style.color = "#017b9f")
                    }
                    onMouseDown={(e) =>
                    ((e.target as HTMLElement).style.transform =
                      "scale(1.05)")
                    }
                    onMouseUp={(e) =>
                      ((e.target as HTMLElement).style.transform = "scale(1)")
                    }
                  >
                    {useRecoveryCode
                      ? "Use OTP instead?"
                      : "Use a recovery code?"}
                  </Link>
                  <Button
                    type="button"
                    onClick={handleOTPSubmit}
                    className="auth-button"
                  >
                    Submit Recovery Password
                  </Button>
                </div>
              )}
            </>
          )}

          {/* <OrDivider>
            <span>or</span>
          </OrDivider> */}
          {/* <Register>
            Don't have an account yet? <a href="#">Register</a>
          </Register> */}
        </Down>
      </Card>
      <Footer>
        By continuing you accept our{" "}
        <Link
          to="/privacypolicy-page"
          style={{ textDecoration: "underline", color: "#017b9f" }}
        >
          Terms of Service
        </Link>{" "}
        and{" "}
        <Link
          to="/privacypolicy-page"
          style={{ textDecoration: "underline", color: "#017b9f" }}
        >
          Privacy Policy
        </Link>
      </Footer>
    </Container>
  );
};

export default Login;
